export type BackendHealthErrorPresentation = {
  title: string;
  message: string;
};

/**
 * Maps readiness/fetch errors to a panel title and message.
 * Known errors get a short explanation; unknown errors pass through the raw detail.
 */
export function presentBackendHealthError(
  rawDetail: string,
  fallbackTitle: string,
): BackendHealthErrorPresentation {
  const errorMessage = rawDetail.trim();

  if (!errorMessage) {
    return {
      title: fallbackTitle,
      message: 'No error details were returned.',
    };
  }

  switch (true) {
    case errorMessage.match(
      /KnexTimeoutError|Timeout acquiring a connection|pool is probably full/i,
    ) != null:
      return {
        title: 'Database connection failed',
        message:
          'Homestead cannot reach the development PostgreSQL database. For local dev: run okta-aws-cli web, start an Alohomora tunnel to dev RDS on localhost:5432 (see CONTRIBUTING.md), then restart ./rundev.sh.',
      };

    case errorMessage.match(
      /Failed to fetch|NetworkError|ECONNREFUSED|ERR_CONNECTION_REFUSED/i,
    ) != null:
      return {
        title: 'Backend not responding',
        message:
          'The development backend is not reachable. Make sure ./rundev.sh is running. If logs mention database timeouts, start the Alohomora tunnel to localhost:5432 before restarting.',
      };

    default:
      return {
        title: fallbackTitle,
        message: errorMessage,
      };
  }
}
